import styles from "./TimePicker.module.css";
import React from "react";

function TimePicker({ theName, theTime = "00:00:00", onTimeChange }) {
  let selections = [];
  let d = new Date("1900-01-01 07:00:00");
  let timeCompare = getServerTime(new Date(theTime));

  //Get the server time as UTC to avoid timezone issues
  function getServerTime(serverTime) {
    let returnedTime =
      (serverTime.getUTCHours() < 10 ? "0" : "") +
      serverTime.getUTCHours() +
      ":" +
      (serverTime.getUTCMinutes() < 10 ? "0" : "") +
      serverTime.getUTCMinutes();
    return returnedTime;
  }

  //Loop through time and marked the selected option as necessary.
  for (let i = 0; i < 64; i++) {
    d.setMinutes(d.getMinutes() + 15);
    if (
      d.toLocaleTimeString([], {
        hourCycle: "h24",
        hour: "2-digit",
        minute: "2-digit",
      }) == timeCompare
    ) {
      selections.push(
        <option
          value={d.toLocaleTimeString([], {
            hourCycle: "h24",
            hour: "2-digit",
            minute: "2-digit",
          })}
          key={d.toISOString()}
          selected
        >
          {d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}
        </option>
      );
    } else {
      selections.push(
        <option
          value={d.toLocaleTimeString([], {
            hourCycle: "h24",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          })}
          key={d.toISOString()}
        >
          {d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}
        </option>
      );
    }
  }

  return (
    <select id="" name={`${theName}Time`} className={styles.select} onChange={onTimeChange}>
      {/* <optgroup className={styles.opt}> */}
      <option value="" key="0">
        Select time
      </option>
      {selections}
      {/* </optgroup> */}
    </select>
  );
}

export default TimePicker;

{
  /* <option value="07:00">7:00 AM</option>
            <option value="07:15">7:15 AM</option>
            <option value="07:30">7:30 AM</option>
            <option value="07:45">7:45 AM</option>
            <option value="08:00">8:00 AM</option>
            <option value="08:15">8:15 AM</option>
            <option value="08:30">8:30 AM</option>
            <option value="08:45">8:45 AM</option>
            <option value="09:00">9:00 AM</option>
            <option value="09:15">9:15 AM</option>
            <option value="09:30">9:30 AM</option>
            <option value="09:45">9:45 AM</option>
            <option value="10:00">10:00 AM</option>
            <option value="10:15">10:15 AM</option>
            <option value="10:30">10:30 AM</option>
            <option value="10:45">10:45 AM</option>
            <option value="11:00">11:00 AM</option>
            <option value="11:15">11:15 AM</option>
            <option value="11:30">11:30 AM</option>
            <option value="11:45">11:45 AM</option>
            <option value="12:00">12:00 PM</option>
            <option value="12:15">12:15 PM</option>
            <option value="12:30">12:30 PM</option>
            <option value="12:45">12:45 PM</option>
            <option value="13:00">1:00 PM</option>
            <option value="13:15">1:15 PM</option>
            <option value="13:30">1:30 PM</option>
            <option value="13:45">1:45 PM</option>
            <option value="14:00">2:00 PM</option>
            <option value="14:15">2:15 PM</option>
            <option value="14:30">2:30 PM</option>
            <option value="14:45">2:45 PM</option>
            <option value="15:00">3:00 PM</option>
            <option value="15:15">3:15 PM</option>
            <option value="15:30">3:30 PM</option>
            <option value="15:45">3:45 PM</option>
            <option value="16:00">4:00 PM</option>
            <option value="16:15">4:15 PM</option>
            <option value="16:30">4:30 PM</option>
            <option value="16:45">4:45 PM</option>
            <option value="17:00">5:00 PM</option>
            <option value="17:15">5:15 PM</option>
            <option value="17:30">5:30 PM</option>
            <option value="17:45">5:45 PM</option>
            <option value="18:00">6:00 PM</option>
            <option value="18:15">6:15 PM</option>
            <option value="18:30">6:30 PM</option>
            <option value="18:45">6:45 PM</option>
            <option value="19:00">7:00 PM</option>
            <option value="19:15">7:15 PM</option>
            <option value="19:30">7:30 PM</option>
            <option value="19:45">7:45 PM</option>
            <option value="20:00">8:00 PM</option>
            <option value="20:15">8:15 PM</option>
            <option value="20:30">8:30 PM</option>
            <option value="20:45">8:45 PM</option>
            <option value="21:00">9:00 PM</option>
            <option value="21:15">9:15 PM</option>
            <option value="21:30">9:30 PM</option>
            <option value="21:45">9:45 PM</option>
            <option value="22:00">10:00 PM</option>
            <option value="22:15">10:15 PM</option>
            <option value="22:30">10:30 PM</option>
            <option value="22:45">10:45 PM</option> */
}
